import { Route, Routes } from "react-router-dom";
import Home from "./Home/home";
import React, { useEffect } from "react";
import { useSidebar } from "../components/ui/sidebar";
import Page from "../pages/Modular/page";
import Gamelist from "../pages/MobileView/GamePage";
import PageHeader from "../components/Page/page_header";
import Profile from "./Settings/profile";

const About = () => <div>Placeholder page</div>; // Placeholder for About page

const PageRoutes = () => {
  // Destructure values from sidebar context
  const { isSidebarOpen, authenticated, structuredPages } = useSidebar();

  // Effect hook that runs whenever isSidebarOpen changes (currently does nothing)
  useEffect(() => {}, [isSidebarOpen]);

  // Component to render a 404 Not Found page
  const NotFound = () => (
    <div className="ml-56 default_page_style w-full">
      <PageHeader title={"Error"} />
      <main className="grid min-h-[calc(100vh-4rem)] place-items-center p-6">
        <div className="w-full max-w-3xl text-center">
          <h1 className="justify-content-center text-[12rem] font-bold tracking-tight bg-gradient-to-r from-blue-600 to-violet-500 bg-clip-text text-transparent leading-none">404</h1>
          <div className="mx-auto my-8 h-1.5 w-24 rounded-full bg-gradient-to-r from-blue-600 to-violet-500" />
          <h2 className="text-4xl font-semibold text-black dark:text-white">Page Not Found</h2>
          <p className="mt-6 text-lg text-gray-500 dark:text-gray-400">The page you're looking for doesn't exist or has been moved.</p>
        </div>
      </main>
    </div>
  );

  // Render subpages for a given page
  const renderSubpages = (page_name, subpages) => {
    return Object.keys(subpages).map((subpageKey) => {
      const subpage = subpages[subpageKey];
      return (
        <Route key={subpageKey} path={subpageKey}>
          <Route index element={<Page containers={subpage.containers} title={page_name} cols={1} type={subpageKey} />} />
        </Route>
      );
    });
  };

  const baseRoutes = [
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/Games", element: <Gamelist /> },
    { path: "/Profile", element: <Profile /> },
    { path: "/Sudoblock", element: null },
    { path: "/Combinations", element: null },
    { path: "/Connections", element: null },
    { path: "/Crossword", element: null },
    { path: "/Minequest", element: null },
    { path: "/Nonogram", element: null },
    { path: "/Solitaire", element: null },
    { path: "/Spelling Bee", element: null },
    { path: "/Sudoku", element: null },
    { path: "/Sudotetroid", element: null },
    { path: "/Word Search", element: null },
    { path: "/Wordle", element: null },
    { path: "/10 Daagse", element: null },
    { path: "/10 Daagse HLN", element: null },
  ];

  return (
    <div>
      {/* Apply padding based on sidebar state */}
      <Routes>
        <Route path="/" element={<Home />} /> {/* Default route for the Home page */}
        {authenticated &&
          Object.keys(structuredPages).map((pageKey) => {
            // Render routes only if authenticated
            const page = structuredPages[pageKey];
            return (
              <Route key={pageKey} path={pageKey}>
                {/* Main route for each page */}
                <Route index element={<Page containers={page.containers} title={pageKey} cols={2} />} /> {/* Render main page content */}
                {page.subpages && renderSubpages(pageKey, page.subpages)} {/* Render subpages if they exist */}
              </Route>
            );
          })}
        {/* Render base valid routes */}
        {baseRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        {/* Render duplicate routes for statistics using "/statistics" prefix */}
        {baseRoutes.map((route) => (
          <Route key={route.path + "-statistics"} path={`${route.path === "/" ? "" : route.path}/Statistics`} element={route.element} />
        ))}
        <Route path="*" element={<NotFound />} /> {/* Route for 404 Not Found */}
      </Routes>
    </div>
  );
};

export default PageRoutes;
